import { createFileRoute } from "@tanstack/react-router";
import { warmSymbolShellFromListRoute } from "~/features/symbol/routing/warm-symbol-shell";
import { createSocialHeadMeta } from "~/lib/social-head";
import { CRYPTO_SOCIAL_METADATA } from "~/lib/social-metadata";

export const Route = createFileRoute("/_app/crypto")({
  head: () => ({
    meta: createSocialHeadMeta(CRYPTO_SOCIAL_METADATA),
  }),
  loader: ({ preload }) => {
    warmSymbolShellFromListRoute(preload);
  },
});
